/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { useEffect, useState } from "react";

import {
	CountryBrandApplicationAttachments,
	NormCertificate,
} from "../../../../domain/CountryBrandApplication";
import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

interface Certificate extends NormCertificate {
	status?: "NEW" | "EDIT" | "DELETE" | "READ";
}

function NormsCertificatiosTable({
	certificates,
	setCertificates,
	attachments,
	setAttachments,
}: {
	certificates: Certificate[];
	setCertificates: React.Dispatch<React.SetStateAction<Certificate[]>>;
	attachments: CountryBrandApplicationAttachments[];
	setAttachments: React.Dispatch<React.SetStateAction<CountryBrandApplicationAttachments[]>>;
}) {
	const [showRowForm, setShowRowForm] = useState(false);
	const [editingRowId, setEditingRowId] = useState(0);
	const [normId, setNormId] = useState("0");
	const [otherNorm, setOtherNorm] = useState("");
	const [updateNormId, setUpdateNormId] = useState(false);
	const normsFiles = attachments.filter((e) => e.type.startsWith("NORM_") && e.status !== "DELETE");

	const norms: string[] = [
		"ASIQUR - Cuidado Responsable del Medio Ambiente",
		"BRCGS",
		"Certificación B",
		"Certificación +G",
		"Certificacion MAS",
		"Certificación OEC",
		"ETI (Ethical Trading Iniciative)",
		"FSSC 22000",
		"GLOBALG.A.P.",
		"INTE - ISO 14064-1:2019, INTE B5:2021 - Norma para demostrar la Carbono Neutralidad",
		"HACCP",
		"INTE B5:2016 - Carbono Neutralidad",
		"ISO 13485",
		"ISO 14001",
		"ISO 14064-1",
		"ISO 21001",
		"ISO 22000",
		"ISO 22716",
		"ISO 27001",
		"ISO 28000",
		"ISO 29993",
		"ISO 39001",
		"ISO 45001",
		"ISO 50001",
		"ISO 9001",
		"ISO/IEC 20000",
		"OCDE - Principios de Buenas Prácticas de Laboratorio",
		"PIC/S Good Manufacturing Practices",
		"SA8000",
		"UNIT 1117",
		"UNIT NM 323",
		"UNIT NM 60669-1:2004",
		"OTRO",
	];

	useEffect(() => {
		if (certificates.length > 0) {
			const certificatesIdList: number[] = certificates
				.map((e) => Number(e.normId))
				.sort(function (a, b) {
					return a - b;
				});
			let iterator = 0;
			let lastNormId = -1;
			while (iterator < certificatesIdList.length && lastNormId < 0) {
				for (let i = 0; i < 32; i++) {
					if (
						(i < certificatesIdList[iterator] && !certificatesIdList.includes(i)) ||
						(i > certificatesIdList[iterator] && i < certificatesIdList[iterator + 1]) ||
						(i > certificatesIdList[iterator] && !certificatesIdList[iterator + 1])
					) {
						lastNormId = i;
						break;
					}
				}
				iterator++;
			}
			setNormId(String(lastNormId));
		}
	}, [updateNormId]);

	async function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
		const file = e.target.files[0];
		if (file) {
			const type = `NORM_${normId === "32" ? otherNorm : normId}`;
			const id = file.name + type;
			setAttachments([
				...attachments
					.filter((att) => !(att.name === file.name && att.type === type && att.status === "ADD"))
					.map((att) =>
						att.name === file.name && att.type === type ? { ...att, status: "DELETE" } : { ...att }
					),
				{
					id,
					name: file.name,
					url: "",
					type,
					status: "ADD",
					file,
				},
			]);
		}
		e.target.value = null;
	}

	function handleClickDeleteAttachmentRow(attachment: CountryBrandApplicationAttachments) {
		if (attachment.status === "ADD") {
			setAttachments(attachments.filter((e) => e.id !== attachment.id));
		} else {
			setAttachments(
				attachments.map((e) => (e.id === attachment.id ? { ...e, status: "DELETE" } : { ...e }))
			);
		}
	}

	function handleChangeNorm(event: React.ChangeEvent<HTMLInputElement>) {
		setNormId(event.target.value);
	}

	function handleChangeOtherNorm(event: React.ChangeEvent<HTMLInputElement>) {
		setOtherNorm(event.target.value);
	}

	function handleClickShowAddRow() {
		if (showRowForm) {
			setShowRowForm(false);
			setNormId("");
		} else {
			setUpdateNormId(!updateNormId);
			setShowRowForm(true);
		}
	}

	function handleClickSaveRow() {
		if (editingRowId) {
			setCertificates(
				certificates.map((s) =>
					s.id === editingRowId
						? {
								id: editingRowId,
								normId: normId === "32" ? otherNorm : normId,
								status: "EDIT",
						  }
						: { ...s }
				)
			);
		} else {
			setCertificates([
				...certificates,
				{
					id: -Math.floor(Math.random() * 10000),
					normId: normId === "32" ? otherNorm : normId,
					status: "NEW",
				},
			]);
		}

		setShowRowForm(false);
		setEditingRowId(0);
		setUpdateNormId(!updateNormId);
		setOtherNorm("");
	}

	function handleClickCancelRow() {
		setShowRowForm(false);
		setEditingRowId(0);
		setUpdateNormId(!updateNormId);
		setOtherNorm("");
	}

	function handleClickEditRow(certificate: Certificate) {
		setEditingRowId(certificate.id);
		if (Number(certificate.normId)) {
			setNormId(certificate.normId);
		} else {
			setNormId("32");
			setOtherNorm(certificate.normId);
		}
	}

	function handleClickDeleteRow(certificate: Certificate) {
		const certificateId = certificate.id;
		const normId = certificate.normId;
		// if (certificateId < 0) {
		setCertificates(certificates.filter((e) => e.id !== certificateId));
		// } else {
		// 	setCertificates(
		// 		certificates.map((e) => (e.id === certificateId ? { ...e, status: "DELETE" } : { ...e }))
		// 	);
		// }

		setAttachments(
			attachments
				.filter((att) => !(att.type === `NORM_${normId}` && att.status === "ADD"))
				.map((att) => (att.type === `NORM_${normId}` ? { ...att, status: "DELETE" } : { ...att }))
		);
	}

	const filteredCertificates = certificates.filter((e) => e.status !== "DELETE");

	return (
		<table>
			<thead>
				<tr>
					<th colSpan={3}>
						<button
							className="btn-small"
							type="button"
							disabled={Boolean(editingRowId) || showRowForm}
							onClick={handleClickShowAddRow}
						>
							Agregar Certificación
						</button>
					</th>
				</tr>
			</thead>
			<tbody>
				{showRowForm && (
					<>
						<tr>
							<th>Normas y Esquemas</th>
							<th>Adjuntar certificados/documentos</th>
							<th></th>
						</tr>
						<tr>
							<td>
								<select name="certificationsNormId" value={normId} onChange={handleChangeNorm}>
									{norms
										.map((e) => (
											<option key={norms.indexOf(e)} value={norms.indexOf(e)}>
												{e}
											</option>
										))
										.filter((e) => !certificates.some((element) => element.normId === e.key))}
								</select>
								{normId === "32" && (
									<textarea
										name="otherNorm"
										placeholder="Especifique"
										defaultValue={otherNorm}
										onChange={handleChangeOtherNorm}
									/>
								)}
							</td>
							<td>
								<input name="normFile" type="file" onChange={handleFileChange} />
								<ul className="attachments-list">
									{normsFiles
										.filter((e) => e.type === `NORM_${normId === "32" ? otherNorm : normId}`)
										.map((e) => {
											return (
												<li key={e.id} className="attachment-item">
													{e.name}{" "}
													<button
														className="btn-small"
														type="button"
														onClick={() => handleClickDeleteAttachmentRow(e)}
													>
														Borrar
													</button>
												</li>
											);
										})}
								</ul>
							</td>
							<td>
								<div className="actionButtonsWrapper">
									<button className="btn-small" type="button" onClick={handleClickSaveRow}>
										Guardar
									</button>
									<button className="btn-small" type="button" onClick={handleClickCancelRow}>
										Cancelar
									</button>
								</div>
							</td>
						</tr>
					</>
				)}
				{filteredCertificates.map((d) => {
					return editingRowId === d.id ? (
						<tr key={d.id}>
							<td>
								<select name="certificationsNormId" value={d.normId} onChange={handleChangeNorm}>
									{norms
										.map((e) => (
											<option key={norms.indexOf(e)} value={norms.indexOf(e)}>
												{e}
											</option>
										))
										.filter(
											(e) =>
												!certificates.some((element) => element.normId === e.key) ||
												d.normId === e.key
										)}
								</select>
								{d.normId === "32" && (
									<textarea
										name="otherNorm"
										placeholder="Especifique"
										defaultValue={otherNorm}
										onChange={handleChangeOtherNorm}
									/>
								)}
							</td>
							<td>
								<input name="normFile" type="file" onChange={handleFileChange} />
								<ul className="attachments-list">
									{normsFiles
										.filter((e) => e.type === `NORM_${d.normId}`)
										.map((e) => {
											return (
												<li key={e.id} className="attachment-item">
													{e.name}{" "}
													<button
														className="btn-small"
														type="button"
														onClick={() => handleClickDeleteAttachmentRow(e)}
													>
														Borrar
													</button>
												</li>
											);
										})}
								</ul>
							</td>
							<td>
								<div className="actionButtonsWrapper">
									<button className="btn-small" type="button" onClick={handleClickSaveRow}>
										Guardar
									</button>
									<button className="btn-small" type="button" onClick={handleClickCancelRow}>
										Cancelar
									</button>
								</div>
							</td>
						</tr>
					) : (
						<tr key={d.id}>
							<td>{norms[Number(d.normId)] ?? d.normId}</td>
							<td>
								<ul className="attachments-list">
									{normsFiles
										.filter((e) => e.type === `NORM_${d.normId}`)
										.map((e) => {
											return (
												<li key={e.id} className="attachment-item">
													{e.status !== "ADD" ? (
														<a
															className="button btn-small"
															download={true}
															href={e.url}
															target="_blank"
															rel="noreferrer"
														>
															{e.name}
														</a>
													) : (
														<span>{e.name}</span>
													)}
												</li>
											);
										})}
								</ul>
							</td>
							<td className="tdActionButtonsWrapper">
								<div className="actionButtonsWrapper">
									<button
										className="btn-small"
										type="button"
										disabled={Boolean(editingRowId) || showRowForm}
										onClick={() => handleClickEditRow(d)}
									>
										Editar
									</button>
									<button
										className="btn-small"
										type="button"
										disabled={Boolean(editingRowId) || showRowForm}
										onClick={() => handleClickDeleteRow(d)}
									>
										Borrar
									</button>
								</div>
							</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
}

function Certifications() {
	const { currentStep, countryBrandApplication, update, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const [certificates, setCertificates] = useState<Certificate[]>([]);

	const [attachments, setAttachments] = useState<CountryBrandApplicationAttachments[]>(
		countryBrandApplication.attachments.map((e) => ({ ...e, status: "READ" }))
	);
	useEffect(() => {
		setCertificates(
			countryBrandApplication.certificationsNorms.map((e) => ({
				...e,
				status: "READ",
				id: e.id ?? -Math.floor(Math.random() * 10000),
			})) ?? []
		);
	}, [countryBrandApplication]);

	useEffect(() => {
		setPreviousStep(currentStep - 1);
		function submitStepData() {
			const certificationsNorms = certificates.map(function (e) {
				return { normId: e.normId };
			});
			update({
				data: {
					certificationsNorms,
					attachments,
				},
				nextStep: currentStep + 1,
			});
		}
		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, [certificates, attachments]);

	return (
		<div className="step-page" id="step-11">
			<section>
				<h3>
					11-Certificaciones: seleccione a continuación únicamente aquellas certificaciones vigentes
					que disponga su organización.
				</h3>
				<NormsCertificatiosTable
					{...{ certificates, setCertificates, attachments, setAttachments }}
				/>
			</section>
		</div>
	);
}

export { Certifications };
